export default function ResumeFromApiReducer(resume = {}, action) {
	switch (action.type) {
		case "RESUME_DATA":
			return action.payload;
		default:
			return resume;
	}
}
